import { TOOLTIPTEXT } from "@/utilities/CommonText";

import { routingConstants } from "./routingConstants";

export const APP_ENV = import.meta.env.VITE_APP_ENV;
export const CHAT_URL = import.meta.env.VITE_APP_CHAT_URL;
export const SERVER_URL = import.meta.env.VITE_APP_SERVER_URL;
export const AGENCY_API_V6_DEVELOPMENT_URL = import.meta.env
  .VITE_APP_AGENCY_API_V6_DEVELOPMENT_URL;

export const FIND_LOCATION_API_KEY = import.meta.env
  .VITE_APP_FIND_LOCATION_API_KEY;

export const PYTHON_SERVICE_MAIN_URL = import.meta.env
  .VITE_APP_PYTHON_SERVICE_URL;

export const ROLLBAR_TOKEN = import.meta.env.VITE_APP_ROLLBAR_TOKEN;

export const BRANCH_IO_KEY_TEST = import.meta.env.VITE_APP_BRANCH_IO_KEY_TEST;
export const BRANCH_IO_KEY_LIVE = import.meta.env.VITE_APP_BRANCH_IO_KEY_LIVE;

export const GOOGLE__MAP_API_KEY = import.meta.env.VITE_APP_GOOGLE_MAP_API_KEY;
export const GOOGLE_MAP_API_ID = import.meta.env.VITE_APP_GOOGLE_MAP_API_ID;

export const IDEAL_POSTCODE_API_KEY = import.meta.env
  .VITE_APP_IDEAL_POSTCODE_API_KEY;

export const SESSION_EXPIRY_TIME = 45;

export const ENCRYPT_LOCAL_STORAGE = false;

export const GROUP_STATUS = {
  ACTIVE: "active",
  INACTIVE: "inactive",
  BLOCK: "block",
  DELETED: "deleted",
};

export const GROUP_TYPE = {
  BROADCAST: "broadcast",
  GROUP: "group",
};

export const CONVERSATION_TYPE = {
  CANDIDATE: "candidate",
  ...GROUP_TYPE,
};

export const WEEK_DAYS_NAMES = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

export const MONTH_NAMES = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const ORDINAL_NUMBERS = [
  "First",
  "Second",
  "Third",
  "Fourth",
  "Fifth",
  "Last",
];

export const ACTION_BTN_HOVER_CLR = {
  yellow: "hover:bg-[#FFF4DC]",
  black: "hover:bg-[rgba(52,54,56,0.2)]",
  red: "hover:bg-[#FCDADA]",
  lightBlue: "hover:bg-lightblue",
  green: "hover:bg-[#E0F2E0]",
};

export const candidateTypeCounts = [
  {
    name: "invited",
    type: "invited",
    value: 0,
    link: routingConstants.invitedCandidate,
    access: "is_allow_to_invited_list",
  },
  {
    name: "unfilled",
    type: "unfilled",
    value: 0,
    link: routingConstants.unfilledContracts,
    access: "is_allow_to_unfilled_list",
  },
  {
    name: "applied",
    type: "applied",
    value: 0,
    link: routingConstants.appliedCandidate,
    access: "is_allow_to_applied_list",
  },
  {
    name: "booked",
    type: "booked",
    value: 0,
    link: routingConstants.bookedCandidate,
    access: "is_allow_to_booked_list",
  },
  {
    name: "worked",
    type: "worked",
    value: 0,
    link: routingConstants.workedCandidate,
    access: "is_allow_to_worked_list",
  },
];

export const timesheetTypeCounts = [
  {
    name: "assigned",
    type: "assigned",
    value: 0,
    link: routingConstants.assignedTimesheet,
    access: "is_allow_to_assigned_timesheet_list",
  },
  {
    name: "submitted",
    type: "submitted",
    value: 0,
    link: routingConstants.submittedTimesheet,
    access: "is_allow_to_submitted_timesheet_list",
  },
  {
    name: "authorised",
    type: "authorised",
    value: 0,
    link: routingConstants.authorisedTimesheet,
    access: "is_allow_to_authorised_timesheet_list",
  },
  {
    name: "disputed",
    type: "terminated",
    value: 0,
    link: routingConstants.terminatedTimesheet,
    access: "is_allow_to_terminated_timesheet_list",
  },
];

export const invoiceTypeCounts = [
  {
    name: "invoices",
    type: "invoices",
    value: 0,
    link: routingConstants.invoice,
    access: "is_allow_to_invoice_list",
  },
];

export const userAccessCounts = [
  {
    name: "roles",
    type: "roles",
    value: 0,
    link: routingConstants.clientRole,
  },
  {
    name: "users",
    type: "users",
    value: 0,
    link: routingConstants.clientUsers,
  },
];

export const listViews = [
  {
    name: "Contracts",
    value: "contracts",
    title: TOOLTIPTEXT.contractView,
  },
  {
    name: "Shifts",
    value: "shifts",
    title: TOOLTIPTEXT.shiftView,
  },
];

export const DEFAULT_BOOKED_LIST_VIEW = "shifts";
export const DEFAULT_WORKED_LIST_VIEW = "contracts";

export const WORKED_STATUS_REDIRECTION_STATUS = [
  "Pending",
  // "Authorised",
  // "Terminated",
  "Invoiced",
  // "Rejected",
  "Worked",
  "Booked",
];
export const WORKED_STATUS_REDIRECTION_LINK = {
  Pending: routingConstants.submittedTimesheet,
  Authorised: routingConstants.authorisedTimesheet,
  Terminated: routingConstants.terminatedTimesheet,
  Rejected: routingConstants.terminatedTimesheet,
  Invoiced: routingConstants.invoice,
  Worked: routingConstants.workedCandidate,
  Booked: routingConstants.bookedCandidate,
};

export const POUND_SIGN = "£";

export const SELECT_EXPORT_PAGES = {
  APPLIED: "applied",
  INVITED: "invited",
  BOOKED: "booked",
  WORKED: "worked",
  UNFILLED: "unfilled",
  SUBMITTED: "submitted",
  ASSIGNED: "assigned",
  AUTHORISED: "authorised",
  TERMINATED: "terminated",
  CONTRACT_SHIFTS: "contract_shifts",
  CONTRACT_TERMINATED_SHIFTS: "contract_terminated_shifts",
  CANDIDATE_DETAIL: "candidate_detail",
  CANDIDATEPAY_INVOICE: "candidate_pay_invoice",
  APPPLOCUM_INVOICE: "applocum_invoice",
};

export const ReasonForMarkAsUnsuitable = [
  {
    name: "Clinical Competence Issues",
    value: "Clinical Competence Issues",
  },
  {
    name: "Poor Communication Skills",
    value: "Poor Communication Skills",
  },
  {
    name: "Inability to Follow Protocols",
    value: "Inability to Follow Protocols",
  },

  {
    name: "Personality Conflicts",
    value: "Personality Conflicts",
  },

  {
    name: "Inadequate Work Rate",
    value: "Inadequate Work Rate",
  },
  {
    name: "Reliability Issues",
    value: "Reliability Issues",
  },

  {
    name: "Mismatch with Team Culture or Dynamics",
    value: "Mismatch with Team Culture or Dynamics",
  },
  {
    name: "Other - [Qualitative answer needed]",
    value: "Other",
  },
];

export const ACTION_BY_FILTERS_KEY = {
  actionedById: null,
  actionedByType: null,
};

export const FeedbackType = [
  {
    name: "Bug/Issue",
    value: "bug_issue",
  },
  {
    name: "Feedback/Change Suggestion",
    value: "feedback_suggestion",
  },
];

export const areaOfBugandChanges = [
  {
    name: "Sign in",
    value: "Sign in",
  },

  {
    name: "Dashboard",
    value: "Dashboard",
  },

  {
    name: "Invited",
    value: "Invited",
  },

  {
    name: "Unfilled",
    value: "Unfilled",
  },

  {
    name: "Applied",
    value: "Applied",
  },

  {
    name: "Booked",
    value: "Booked",
  },

  {
    name: "Worked",
    value: "Worked",
  },

  {
    name: "Candidate Profile",
    value: "Candidate Profile",
  },
  {
    name: "Contract Detail",
    value: "Contract Detail",
  },

  {
    name: "Timesheets",
    value: "Timesheets",
  },

  {
    name: "Invoices",
    value: "Invoices",
  },

  {
    name: "My Profile",
    value: "My Profile",
  },
  {
    name: "Messaging",
    value: "Messaging",
  },

  {
    name: "Notifications",
    value: "Notifications",
  },
  {
    name: "Branch Management",
    value: "Branch Management",
  },
  {
    name: "User Access",
    value: "User Access",
  },
];
